//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FactoryUtils } from "@/utils/FactoryUtils"    
export default {
    data(){
        return {
           show:false,
           serviceList:[]
        }
    },
    props: {
        type: {
            type: String,
        },
    },
    mounted() {
       FactoryUtils.service().then(res =>{
          this.serviceList = res
       })
    },
    methods:{
        showoast(){
            this.show = true
        },
        closeClick(){
            this.show = false
        }
    }
}
